import { DateInputConstant } from 'config';

export const isDateInputLengthValid = (input: string | null) => {
  if (!input) return false;

  return input.length === DateInputConstant.TEMPLATE.length;
};

const isDateObjValid = (date: string) =>
  !Number.isNaN(new Date(date).getTime());

export const applyInputDate = (
  newValue: string | null,
  applier?: (v: Date | null) => void,
  error?: () => void,
) => {
  if (isDateInputLengthValid(newValue)) {
    const newDateString =
      newValue?.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, '$3-$2-$1') || '';

    if (isDateObjValid(newDateString)) {
      const newDate = new Date(newDateString);

      applier && applier(newDate);
    } else {
      error && error();
    }
  }
};

export const dateInputProcessor = (proc: string) => {
  if (!proc) return null;

  const process = /^(\d{1,2})?\/?(\d{1,2})?\/?(\d{1,4})?$/.exec(proc);
  if (!process) return null;

  return process.reduce((val, item, ind) => {
    if (!ind || !item) return val;

    if (item.length === 1 || ind === 3) return `${val}${item}`;

    return `${val}${item}/`;
  }, '');
};

export const isDateInputValid = (dateDigits: string) => {
  if (!dateDigits.length) return true;

  const inTest = Number(dateDigits.slice(-1));

  // Warning! Hardcoded value, year starts only from 2
  if (dateDigits.length === 7 && inTest === DateInputConstant.MILLENNIUM)
    return true;

  // Warning! Hardcoded value, the second year digit can be only 0
  if (dateDigits.length === 8 && inTest === DateInputConstant.CENTURY)
    return true;

  // Warning! Hardcoded value, the third year digit can't be 0
  if (dateDigits.length === 9 && inTest === 0) return false;

  const digits = /(\d{0,2})(\d{0,2})(\d{0,4})/.exec(
    dateDigits.replace(/\D/g, ''),
  );

  const dd = (digits && Number(digits[1].padEnd(2, '0'))) || 0;

  const mm = (digits && Number(digits[2].padEnd(2, '0'))) || 0;

  const yy = digits?.[3] || `${DateInputConstant.MIN_AVAILABLE_YEAR}`;

  if (yy?.length === 3) {
    const lastYearNumber = Number(yy.slice(-1));
    return lastYearNumber > 0 && lastYearNumber < 4;
  }

  // Warning! Hardcoded value, see constants for min and max years
  if (
    dd <= DateInputConstant.MAX_DAY_IN_MONTH &&
    mm <= DateInputConstant.MAX_MONTH_IN_YEAR &&
    Number(yy) >= DateInputConstant.MIN_AVAILABLE_YEAR &&
    Number(yy) <= DateInputConstant.MAX_AVAILABLE_YEAR
  ) {
    return true;
  }

  return false;
};
